import { Task } from "./Plan"
import { useContext } from 'react'
import { PlanBuilderContext } from './Plan'
import FrmTask from "./frmTask"
import ShowAlert from "@/hooks/show-alert"
import { CloseIcon, DeleteIcon } from "../ui/Icons/TooltipIcon"
import DeleteButton from "../ui/delete-button"

interface TaskBuilderProps {
    task : Task
}

const TaskBuilder = ({ task } : TaskBuilderProps) => {
  const props = useContext(PlanBuilderContext);
  const dependents = props.getDependents(task.id);

  return (
    <div className="flex flex-col border-2 border-gray-500 rounded-md ml-2 min-w-[450px] h-min">
        <div className={"flex flex-row justify-between items-center " + (task.isMilestone ? "bg-planbuilder-milestone" : "bg-planbuilder-task") +  " text-planbuilder-task-header-foreground px-2"}>
            <div>
                {task.name}
            </div>
              <div className='flex flex-row my-auto'>
                {dependents.length > 0 ? 
                <ShowAlert
                title={"Delete Task?"}
                message={"This task is a dependency of " + dependents.toString() + " and cannot be deleted."}
                >
                  <DeleteIcon
                  tooltip={"This task is a dependency of " + dependents.toString() + " and cannot be deleted."}
                  />
                </ShowAlert>
                : 
                <DeleteButton
                  action={() => props.deleteTask(task.id)}
                  title={"Delete Task?"}
                  message={"Are you sure you want to delete " + task.name + "?"}
                  tooltip={"Delete " + task.name}
                />
                }
                <div className='my-auto' onClick={() => props.setShowEditForm(false)} ><CloseIcon className="text-white rounded-md cursor-pointer hover:bg-red-500" /></div>
              </div>
            </div>
            <div className="flex flex-row p-4 w-full">
              <div className="flex flex-col w-full">
                <FrmTask task={task}/>
              </div>
            </div>
        
    </div>
  )
}

export default TaskBuilder